import { TipoError } from './types';

export const ERROR_UI: Record<
  TipoError,
  { label: string; color: string; prioridad: number }
> = {
  ALERTA_TOLERANCIA: { label: 'Alerta tolerancia', color: 'danger', prioridad: 1 },
  'SIN-ASIGNACION': { label: 'Sin asignación', color: 'danger', prioridad: 1 },
  'SIN-ENTRADA': { label: 'Sin entrada', color: 'warning', prioridad: 2 },
  'SIN-SALIDA': { label: 'Sin salida', color: 'warning', prioridad: 2 },
  SUPERA: { label: 'Supera', color: 'tertiary', prioridad: 3 },
  REPETIDA: { label: 'Repetida', color: 'medium', prioridad: 4 },
};

export const TIPOS_EN_ORDEN: TipoError[] = [
  'ALERTA_TOLERANCIA',
  'SIN-ASIGNACION',
  'SIN-ENTRADA',
  'SIN-SALIDA',
  'SUPERA',
  'REPETIDA',
];
